import React, { createContext, useContext, useEffect, useState } from "react";
import env from "../services/env";
import defaultLogo from "../assets/images/logo.png";

const DEFAULT_COLOR = "#fcd535";
const BrandingContext = createContext({ logo: defaultLogo, primaryColor: DEFAULT_COLOR });

export const BrandingProvider = ({ children }) => {
  const [branding, setBranding] = useState({ logo: defaultLogo, primaryColor: DEFAULT_COLOR });

  useEffect(() => {
    document.documentElement.style.setProperty("--brand-color", branding.primaryColor);
  }, [branding.primaryColor]);

  useEffect(() => {
    fetch(env.url + "/branding", { headers: { Accept: "application/json" } })
      .then((res) => res.json())
      .then((res) => {
        const data = res?.data;
        if (!data) return;
        setBranding({
          logo: data.logo_url || defaultLogo,
          primaryColor: /^#[0-9a-fA-F]{6}$/.test(data.primary_color) ? data.primary_color : DEFAULT_COLOR,
        });
      })
      .catch(() => {});
  }, []);

  return <BrandingContext.Provider value={branding}>{children}</BrandingContext.Provider>;
};

export const useBranding = () => useContext(BrandingContext);
